import _ from 'lodash';
import * as Phone from 'libphonenumber-js';

export function formatPhoneNumber(value?: string) {
  if (!value) {
    return '';
  }
  const stripped = value.replace(/\D/g, '').slice(0, 10); // strip out any non-digit characters, capped at 10
  let formatted = '';
  if (stripped.length > 0) {
    formatted += `(${stripped.slice(0, 3)}`;
  }
  if (stripped.length > 3) {
    formatted += `) ${stripped.slice(3, 6)}`;
  }
  if (stripped.length > 6) {
    formatted += `-${stripped.slice(6, 10)}`;
  }
  return formatted;
}

export function isValid(number: string): boolean {
  const parsed = Phone.parseNumber(number, 'US');
  if (_.isEmpty(parsed)) return false;
  return Phone.isValidNumber(parsed as Phone.ParsedNumber);
}
